import React from "react";

/**
 *
 * @param {Object} props - The props object
 * @param {Array} props.options - The options to be displayed in the select
 * @param {string} props.value - The value of the select
 * @param {function} props.onChange - The function to be called when the select value changes
 * @param {string} [props.className="custInput qualy"] - The class name of the select
 * @returns {JSX.Element} - A select element
 */
export default function Select({
  name,
  options,
  value,
  onChange,
  className = "custInput qualy",
}) {
  return (
    <select name={name} value={value} onChange={onChange} className={className}>
      {options.map((option, index) => (
        <option key={index} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
}
